<!--供应商合同-展示-->
<template>
  <div class="form-detail">
    <div class="container">
      <div class="window_print-content-remiburse-content">
        <div
          class="window_print-content-remiburse-content-node"
          style="border: 1px solid #ced4da"
        >
          <div>
            <div>审批流程</div>
            <!-- <div></div>
             <div>审批状态</div> -->
          </div>
         <div class="all-part">
           <div class="one-part">
            <div class="title">盖章流程</div>
            <div v-for="(i, k) in gaizhangProcess" :key="k" class="all-process">
              <div>{{ i.englishName }}</div>
              <div class="print-process">
                <div
                  :class="{ noShow: k == 0 }"
                  class="print-process-dashed--left"
                ></div>
                <div class="print-process-circle">
                  <div></div>
                </div>
                <div
                  :class="{ noShow: k == gaizhangProcess.length - 1 }"
                  class="print-process-dashed--right"
                ></div>
              </div>
              <div>{{ i.content }}</div>
            </div>
          </div>
             <div class="one-part">
            <div class="title">打款流程</div>
            <div v-for="(i, k) in dakuanProcess" :key="k" class="all-process">
              <div>{{ i.englishName }}</div>
              <div class="print-process">
                <div
                  :class="{ noShow: k == 0 }"
                  class="print-process-dashed--left"
                ></div>
                <div class="print-process-circle">
                  <div></div>
                </div>
                <div
                  :class="{ noShow: k == dakuanProcess.length - 1 }"
                  class="print-process-dashed--right"
                ></div>
              </div>
              <div>{{ i.content }}</div>
            </div>
          </div>
         </div>
         </div>
      </div>

      <h3 style="margin-top: 10px">业务概览</h3>
      <div style="position: relative">
        <div class="ver-tabs">
          <ul>
            <li
              v-for="n in verCount"
              :class="{ active: n === activeVer + 1 }"
              @click="changeVer(n - 1)"
            >
              {{ "V" + (verCount - n + 1) }}
            </li>
          </ul>
        </div>
      </div>

      <i-form
        label-position="left"
        :label-width="120"
        class="default-form client-contract"
      >
        <!-- 基础信息 -->
        <div class="contract-form-group">
          <div>
            <Row>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="合同名称" class="default-form-item" required>
                  <i-input
                    :value="formContent.basicInfo.contractName.value"
                    readonly
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="合同ID" class="default-form-item" required>
                  <i-input
                    readonly
                    :value="selectedTask.contactsCode"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="24" class="default-form-member-col">
                <FormItem label="截止时间" class="default-form-item" required>
                  <DatePicker
                    readonly
                    transfer
                    class="deadline"
                    type="datetime"
                    placeholder="设置截止时间"
                    :value="formContent.basicInfo.endTime.value"
                    :clearable="false"
                  ></DatePicker>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="项目名称" class="default-form-item" required>
                  <i-input
                    v-model="projectInfo.projectName"
                    readonly
                    placeholder="项目名称"
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="项目ID" class="default-form-item" required>
                  <i-input
                    v-model="projectInfo.projectCode"
                    readonly
                    placeholder="自动填充"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="供应商名称" class="default-form-item" required>
                  <i-input
                    v-model="taskData.info.supplierName"
                    readonly
                    placeholder="供应商名称"
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="供应商ID" class="default-form-item" required>
                  <i-input
                    v-model="formContent.basicInfo.supplierName.value"
                    readonly
                    placeholder="自动填充"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="合同类型" class="default-form-item" required>
                  <i-input
                    v-model="contractType"
                    placeholder="合同类型"
                    readonly
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="合同期限" class="default-form-item" required>
                  <DatePicker
                    class="deadline"
                    v-model="formContent.modifyInfo.contractDeadline.value"
                    readonly
                    type="daterange"
                    split-panels
                    placeholder="请设置合同期限"
                    :clearable="false"
                  ></DatePicker>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div v-if="formContent.basicInfo.contractType.value === '6'">
            <Row>
              <i-col span="24" class="default-form-member-col">
                <FormItem label="合同类型备注" class="default-form-item">
                  <i-input
                    v-model="formContent.basicInfo.contractTypeRemark.value"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row type="flex">
              <i-col span="12" class="default-form-member-col">
                <FormItem label="组织单位" class="default-form-item" required>
                  <RadioGroup
                    size="large"
                    v-model="formContent.basicInfo.organizeUnit.value"
                    style="padding-left: 24px"
                  >
                    <Row>
                      <i-col span="12">
                        <Radio
                          label="1"
                          disabled
                          style="height: 53px; line-height: 53px"
                          >公司</Radio
                        >
                      </i-col>
                      <i-col span="12">
                        <Radio
                          label="2"
                          disabled
                          style="height: 53px; line-height: 53px"
                          >个人</Radio
                        >
                      </i-col>
                    </Row>
                  </RadioGroup>
                </FormItem>
              </i-col>
              <i-col span="12" style="background: white"></i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="24" class="default-form-member-col">
                <FormItem
                  label="业务类型"
                  class="default-form-item financeToolkit"
                  required
                >
                  <Cascader
                    :value="toNumberList"
                    :data="bussinessTypeList"
                    disabled
                    placeholder
                  ></Cascader>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div v-if="formContent.basicInfo.bussinessType.value === '21'">
            <Row>
              <i-col span="24" class="default-form-member-col">
                <FormItem label="业务类型备注" class="default-form-item">
                  <i-input
                    v-model="formContent.basicInfo.bussinessTypeRemark.value"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div>
            <Row>
              <i-col span="24" class="default-form-member-col">
                <FormItem label="业务概述" class="default-form-item" required>
                  <i-input
                    v-model="formContent.basicInfo.bussinessOverview.value"
                    readonly
                    placeholder="请输入业务概述"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div v-if="formContent.basicInfo.money.value">
            <Row type="flex">
              <i-col span="12" class="default-form-member-col">
                <FormItem label="是否为代付" class="default-form-item" required>
                  <RadioGroup
                    size="large"
                    v-model="formContent.modifyInfo.insteadPay.value"
                    style="padding-left: 24px"
                  >
                    <Row>
                      <i-col span="12">
                        <Radio
                          disabled
                          label="1"
                          style="height: 53px; line-height: 53px"
                          >是</Radio
                        >
                      </i-col>
                      <i-col span="12">
                        <Radio
                          disabled
                          label="0"
                          style="height: 53px; line-height: 53px"
                          >否</Radio
                        >
                      </i-col>
                    </Row>
                  </RadioGroup>
                </FormItem>
              </i-col>
              <i-col span="12" style="background: white"></i-col>
            </Row>
          </div>
          <div v-if="formContent.basicInfo.money.value">
            <Row type="flex">
              <i-col span="12" class="default-form-member-col">
                <FormItem label="金额" class="default-form-item" required>
                  <i-input
                    :value="formatMoney(formContent.basicInfo.money.value)"
                    readonly
                    placeholder="请输入金额"
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="付款方式" class="default-form-item" required>
                  <RadioGroup
                    size="large"
                    v-model="formContent.basicInfo.payType.value"
                    style="padding-left: 24px"
                  >
                    <Row>
                      <i-col span="12">
                        <Radio
                          label="1"
                          disabled
                          style="height: 53px; line-height: 53px"
                          >单次付款</Radio
                        >
                      </i-col>
                      <i-col span="12">
                        <Radio
                          label="0"
                          disabled
                          style="height: 53px; line-height: 53px"
                          >分期付款</Radio
                        >
                      </i-col>
                    </Row>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div v-if="formContent.basicInfo.money.value">
            <Row type="flex">
              <i-col span="12" class="default-form-member-col">
                <FormItem label="发票" class="default-form-item" required>
                  <i-input
                    :value="formContent.secondModifyInfo.invoice.value"
                    readonly
                    placeholder="请选择发票"
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="税率" class="default-form-item" required>
                  <input-number
                    :value="formContent.secondModifyInfo.taxRate.value"
                    :formatter="(value) => `${value === '' ? '' : value + '%'}`"
                    :parser="(value) => value.replace('%', '')"
                    :min="0"
                    readonly
                    placeholder="请输入税率"
                  ></input-number>
                </FormItem>
              </i-col>
            </Row>
          </div>
          <div v-show="formContent.basicInfo.payType.value === '0'">
            <Row>
              <i-col span="24">
                <FormItem label="备注" class="default-form-item" required>
                  <i-input
                    v-model="formContent.modifyInfo.remark.value"
                    readonly
                    placeholder="请注明分几次付款，每次付款时间和金额"
                    type="textarea"
                    :autosize="true"
                  ></i-input>
                </FormItem>
              </i-col>
            </Row>
          </div>

          <div></div>
        </div>
        <new-file-address
          :address="newTaskAddress"
          :edit="taskData.roleInfo.new_gaizhang_file == 'show'"
        ></new-file-address>

        <!-- 供应商结算单 -->

        <quotation-list
          :task-info="taskData.info"
          :project-info="projectInfo"
          :form-content="formContent"
          style="margin: 20px 0"
        ></quotation-list>

        <!--    打款发票信息    -->
        <div style="polition: relative">
          <h3
            v-if="contactPayFile != ''"
            style="margin-bottom: 10px; display: inline-block; text-align: left"
          >
            打款申请表
          </h3>
          <div
            style="display: inline-block; position: absolute; right: 0"
            v-if="
              contactPayFile &&
              contactPayFile.length &&
              newfukuanexport === 'show'
            "
          >
            <Button type="primary" @click="exporthetongfukuanlist" style=""
              ><Icon type="archive"></Icon> 导出付款</Button
            >
          </div>
        </div>

        <div class="new-table" v-if="contactPayFile != ''">
          <el-table
            :data="contactPayFile"
            border
            style="width: 100%; border: 1px solid #d3d8dd"
            :cell-style="{ background: '#fff', borderColor: '#D3D8DD' }"
            :header-cell-style="{ borderColor: '#D3D8DD' }"
          >
            <el-table-column
              prop="priceTotal"
              label="付款金额"
              width="120"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{ twoFixed(scope.row.priceTotal) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="期望时间"
              width="120"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.endTime ? scope.row.endTime.slice(0, 10) : "" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="pmReason"
              label="付款事由"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="invoiceNo"
              label="发票号"
              header-align="center"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.invoiceNo ? scope.row.invoiceNo : "/" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fuStateName"
              label="付款状态"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <template
              v-if="
                formContent.basicInfo.involveMoney.value == 1 &&
                taskData.info.priceNeedFu !== 'hide'
              "
            >
              <el-table-column
                prop="priceNeedFuEach"
                label="剩余待付金额"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  {{ twoFixed(scope.row.priceNeedFuEach) }}
                </template>
              </el-table-column>
            </template>

            <el-table-column
              prop=""
              label="操作"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <Poptip
                  confirm
                  transfer
                  title="确定作废该打款申请？"
                  placement="bottom"
                  @on-ok="deleteApply(scope.row)"
                  ok-text="确定"
                  cancel-text="取消"
                  style="width: 100%"
                  v-if="scope.row.new_fukuan_delete === 'show' ? true : false"
                >
                  <!-- :disabled="
                      scope.row.new_fukuan_delete === 'show' ? false : true
                    " -->

                  <el-button
                    type="text"
                    v-if="scope.row.new_fukuan_delete === 'show' ? true : false"
                    :class="
                      scope.row.new_fukuan_delete === 'show' ? 'blue' : 'gray'
                    "
                    icon="el-icon-delete"
                    >作废</el-button
                  >
                </Poptip>
                <div v-if="scope.row.new_fukuan_audit === 'show'">
                  <el-button
                    style="color: #2d8ef8; margin-right: 5px"
                    icon="el-icon-circle-check"
                    type="text"
                    :loading="scope.row.applyBtn"
                    @click="() => reviewFukuan(scope.row.kfId, 6, scope, row)"
                    >审核通过</el-button
                  >
                  <el-button
                    style="color: #e02020"
                    :loading="scope.row.rejectBtn"
                    @click="() => showFeelModal(scope.row.kfId, 7, scope.row)"
                    icon="el-icon-circle-close"
                    type="text"
                    >拒绝通过</el-button
                  >
                </div>
                <div
                  v-if="
                    scope.row.new_fukuan_audit !== 'show' &&
                    scope.row.new_fukuan_delete !== 'show'
                  "
                >
                  /
                </div>
              </template>
            </el-table-column>
          </el-table>
          <i-col span="24" class="new-inspect">
            <FormItem label="供应商交付物" class="default-form-item" required>
              <!-- <i-input
                :value="taskData.info.inspectedReason"
                readonly
              ></i-input> -->
              <div class="inspectedReason-jump">
                <template v-for="(item, index) in inspectedReason">
                  <a :href="item" target="_blank">{{ item }} </a>
                  <span v-if="index != inspectedReason.length - 1">,</span>
                </template>
              </div>
            </FormItem>
          </i-col>
        </div>
        <!-- 毛利控制表 -->
        <profit-table :project-info="projectInfo"></profit-table>

        <div class="infor-account">
          <h3>账户信息</h3>
          <Form label-position="right" :label-width="120">
            <div class="contract-form-group new-item">
              <div>
                <Row class="new-required-label">
                  <i-col span="12" class="default-form-member-col">
                    <FormItem
                      label="甲方名称"
                      class="default-form-item"
                      required
                    >
                      <i-input
                        v-model="formContent.partyA.accountName.value"
                        readonly
                        placeholder="甲方名称"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem
                      label="乙方名称"
                      class="default-form-item"
                      required
                    >
                      <i-input
                        v-model="formContent.partyB.name.value"
                        readonly
                        placeholder="乙方名称"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div>
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方联系人" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.contactPerson.value"
                        readonly
                        placeholder="请输入甲方联系人姓名"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方联系人" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.contactPerson.value"
                        readonly
                        placeholder="请输入乙方联系人姓名"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div v-if="formContent.basicInfo.involveMoney.value == 1">
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方账户名称" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.accountName.value"
                        readonly
                        placeholder="请输入甲方账户名称"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方账户名称" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.accountName.value"
                        readonly
                        placeholder="请输入乙方账户名称"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div v-if="formContent.basicInfo.involveMoney.value == 1">
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方账户税号" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.accountTaxNum.value"
                        readonly
                        placeholder="请输入甲方账户税号"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方账户税号" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.accountTaxNum.value"
                        readonly
                        placeholder="请输入乙方账户税号"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div v-if="formContent.basicInfo.involveMoney.value == 1">
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方开户银行" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.openBank.value"
                        readonly
                        placeholder="请输入甲方开户银行"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方开户银行" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.openBank.value"
                        readonly
                        placeholder="请输入乙方开户银行"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div>
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方公司电话" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.companyMobile.value"
                        readonly
                        placeholder="请输入甲方公司电话"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方公司电话" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.companyMobile.value"
                        readonly
                        placeholder="请输入乙方公司电话"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>

              <div v-if="formContent.basicInfo.involveMoney.value == 1">
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方开户账号" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.openAccount.value"
                        readonly
                        placeholder="请输入甲方开户账号"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方开户账号" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.openAccount.value"
                        readonly
                        placeholder="请输乙方入开户账号"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
              <div>
                <Row>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="甲方公司地址" class="default-form-item">
                      <i-input
                        v-model="formContent.partyA.companyAddress.value"
                        readonly
                        placeholder="请输入甲方公司地址"
                      ></i-input>
                    </FormItem>
                  </i-col>
                  <i-col span="12" class="default-form-member-col">
                    <FormItem label="乙方公司地址" class="default-form-item">
                      <i-input
                        v-model="formContent.partyB.companyAddress.value"
                        readonly
                        placeholder="请输入乙方公司地址"
                      ></i-input>
                    </FormItem>
                  </i-col>
                </Row>
              </div>
            </div>
          </Form>
        </div>
        <!-- 任务日志 -->
        <div class="file-log-title">
          <h3>任务日志</h3>
        </div>

        <file-log :log-list="logList" :inspect-files="inspectList"></file-log>
        <!-- 按钮 -->
        <div v-if="!disableControl" class="contract-btn">
          <router-link
            v-if="taskData.roleInfo.eidt !== 'hide'"
            :to="{
              name: 'tasks-editTask',
              params: {
                taskId: taskData.info.id,
                customerId: this.projectInfo.customerId,
                projectId: this.projectInfo.projectId,
              },
              query: { type: 'supplierContract', toolkitId: 7 },
            }"
          >
            <Button type="ghost" class="btn ghost-btn" size="large"
              >编辑任务</Button
            >
          </router-link>
          <Button
            v-if="taskData.roleInfo.new_baojiadan_add !== 'hide'"
            type="ghost"
            class="btn ghost-btn"
            size="large"
            @click="addQuotation()"
            >添加项目结算单</Button
          >

          <Button
            type="primary"
            class="btn"
            size="large"
            @click="hetongseal(2)"
            :loading="hetongApproved"
            v-if="taskData.roleInfo.new_gaizhang_audit === 'show'"
            >审核通过</Button
          >

          <Button
            v-if="taskData.roleInfo.new_gaizhang_audit == 'show'"
            type="ghost"
            class="btn ghost-btn"
            @click="zhijianModal = true"
            :disabled="hetongApproved"
            >审核不通过</Button
          >

          <Button
            v-if="taskData.roleInfo.new_gaizhang_file == 'show'"
            type="primary"
            class="btn"
            @click="hetongsealfile()"
            :loading="hetongSumit"
            >提交</Button
          >
          <router-link
            v-if="taskData.roleInfo.new_fukuan_apply == 'show'"
            :to="{
              name: 'tasks-addTask',
              params: {
                customerId: selectedTask.customerId,
                projectId: selectedTask.projectId,
                productId: 7,
                toolkitId: 20,
              },
              query: { task: selectedTask.id },
            }"
          >
            <Button type="primary" class="btn" style="margin-left: 10px"
              >申请打款</Button
            >
          </router-link>

          <Button
            v-if="taskData.roleInfo.new_fukuan_money == 'show'"
            type="primary"
            class="btn"
            @click="audit(8, undefined, taskAddress)"
            >确认已收款</Button
          >

          <Button
            v-if="taskData.roleInfo.new_pmAudit !== 'hide'"
            type="ghost"
            class="btn ghost-btn"
            size="large"
            @click.native="review(8)"
            >任务已完成</Button
          >
        </div>
      </i-form>
    </div>

    <Modal
      v-model="feedModal"
      class-name="vertical-center-modal examine-modal"
      ok-text="提交意见"
      :closable="false"
      @on-ok="submitAdvice"
      :mask-closable="!rejectBtn"
      :loading="true"
    >
      <div class="advice-repo">
        <Row>
          <i-col span="24">
            <div class="g-mb-16">
              <h4 class>意见反馈</h4>
              <i-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                v-model="repo"
              ></i-input>
            </div>
          </i-col>
        </Row>
      </div>
    </Modal>
    <Modal
      v-model="zhijianModal"
      class-name="vertical-center-modal examine-modal"
      ok-text="提交"
      :closable="false"
      :loading="hetongunApproved"
      :mask-closable="!hetongunApproved"
      @on-ok="hetongseal(-2)"
    >
      <i-input
        type="textarea"
        v-model="zhijianReason"
        :autosize="{ minRows: 5 }"
        placeholder="填写不通过的理由"
      ></i-input>
      <span
        class="words-count"
        :class="{ 'over-length': zhijianReason.length > 1000 }"
        >{{ zhijianReason.length }}/1000</span
      >
      <div slot="footer" class="custom-footer">
        <Button
          type="primary"
          size="large"
          class="ok"
          :loading="hetongunApproved"
          @click.native="hetongseal(-2)"
          :disabled="zhijianReason.length > 1000 || zhijianReason.length == 0"
          >提交</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="isModal"
      class-name="vertical-center-modal examine-modal"
      ok-text="提交"
      width="480px"
      :closable="false"
    >
      <i-input
        type="textarea"
        v-model="modalValue"
        @on-focus.once="clearModalValue"
        :autosize="{ minRows: 5 }"
        placeholder="填写不通过的理由"
      ></i-input>
      <span
        class="words-count"
        :class="{ 'over-length': modalValue.length > 1000 }"
        >{{ modalValue.length }}/1000</span
      >
      <div slot="footer" class="custom-footer">
        <Button
          type="primary"
          size="large"
          class="ok"
          @click.native="audit(nopassState, modalValue, [])"
          :disabled="modalValue.length > 1000"
          >提交</Button
        >
      </div>
    </Modal>
    <toast :is-toast="isToast" :msg="toastMsg" :status="toastState"></toast>
  </div>
</template>
<script>
import profitTable from "./profitTable";
import MemberAdd from "../../MemberAdd";
import fileAddress from "../components/fileAddress.vue";
import newFileAddress from "../components/newFileAddress.vue";
import fileLog from "../components/fileLog.vue";
import { Task, Hr } from "../../../API/api";
import Toast from "../../popup/Toast";
import { defaultPlaceholder } from "../../../assets/conf/taskDefaultIpt";
import quotationList from "../components/quotationList.vue";
import { OptList } from "../../../assets/conf/businessType.conf.js";
import { thousandSplit, yunzhouAdress } from "../../../util/util.js";
import ProfitTable from "./profitTable.vue";

export default {
  name: "supplier-contract",
  components: {
    MemberAdd,
    Toast,
    fileAddress,
    newFileAddress,
    fileLog,
    quotationList,
    profitTable,
    ProfitTable,
  },
  props: {
    taskData: Object,
    formContent: Object,
    taskInfo: Object,
    verCount: Number,
    activeVer: Number,
    projectInfo: Object,
    logList: {
      type: [Array, Object],
      default: function () {
        return [];
      },
    },
  },
  mounted() {},
  created() {
    this.getSupplier();
  },
  data() {
    return {
      hetongApproved: false,
      hetongunApproved: false,
      hetongSumit: false,
      rejectBtn: false,
      zhijianModal: false,
      isModal: false,
      editfile: false,
      zhijianReason: "",
      repo: "",
      fukuanId: undefined,
      toastState: "",
      toastMsg: "",
      modalValue: "",
      isToast: false,
      nopassState: null,
      canAudit: true,
      feedModal: false,
      suppliers: [],
      contactPayFile: [],
      newfukuanexport: "hide",
      businessTypeConf: [
        { value: "3", label: "业务制作" },
        {
          value: "",
          label: "媒体制作",
          children: [
            { value: "4", label: "KOL" },
            { value: "5", label: "艺人" },
            { value: "6", label: "模特" },
          ],
        },
        { value: "7", label: "KOL采购" },
        { value: "8", label: "媒体采购" },
        { value: "9", label: "文案" },
        { value: "10", label: "技术研发" },
        { value: "11", label: "排版" },
        { value: "12", label: "插画" },
        { value: "13", label: "线框图" },
        { value: "14", label: "方案" },
        { value: "15", label: "租赁服务器" },
        { value: "16", label: "视频制作" },
        { value: "17", label: "摄像" },
        { value: "18", label: "摄影" },
        { value: "19", label: "艺人费用" },
        { value: "20", label: "监测与报告" },
        { value: "21", label: "其他" },
      ],
      sealConf: [
        { id: "1", label: "客户合同" },
        { id: "2", label: "声明" },
        { id: "3", label: "报价单" },
        { id: "4", label: "外发合同" },
        { id: "5", label: "保密协议" },
        { id: "6", label: "其他" },
        { id: "7", label: "项目合同" },
        { id: "8", label: "框架合同 " },
        { id: "9", label: "报价单/结算单" },
      ],

      bussinessTypeList: JSON.parse(JSON.stringify(OptList)),
      logListOne: [],
      gaizhangProcess:[],
      dakuanProcess:[],
    };
  },
  computed: {
    inspectedReason() {
      let inspectedReason;
      if (this.taskData.info.inspectedReason != null) {
        this.taskData.info.inspectedReason =
          this.taskData.info.inspectedReason.replace(/；/gi, ";");
        inspectedReason = this.taskData.info.inspectedReason.split(";");
      } else {
        inspectedReason = this.taskData.info.inspectedReason;
      }

      return inspectedReason;
    },
    disableControl() {
      return this.$route.name === "supplierContract";
    },
    inspectList() {
      return this.taskData.inspectFiles;
    },
    taskAddress() {
      if (this.taskData.gaizhangFile.length) {
        return this.taskData.gaizhangFile;
      } else {
        return [
          {
            fileName: "",
            url: "",
          },
        ];
      }
    },
    newTaskAddress() {
      return this.taskData.gaizhangFile[0];
    },
    supplierName() {
      let supplier = this.suppliers.find(
        (item) => item.id === this.formContent.basicInfo.supplierId.value
      );
      return supplier && supplier.customerName;
    },
    contractType() {
      let contractType = this.sealConf.find(
        (item) => item.id === this.formContent.basicInfo.contractType.value
      );
      return contractType && contractType.label;
    },
    bussinessType() {
      const v = this.formContent.basicInfo.bussinessType.value;
      const result = this.businessTypeConf.find((i) => i.value === v);
      return result ? result.label : "";
    },
    selectedTask() {
      return this.$store.state.taskDetail;
    },
    toNumberList() {
      let businessType = [];
      if (typeof this.formContent.basicInfo.bussinessType.value == "object") {
        this.formContent.basicInfo.bussinessType.value.forEach((ele) => {
          businessType.push(Number(ele));
        });
      }
      return businessType;
    },
  },
  watch: {
    /* 切换查看文件时重新查询打款数据 */
    selectedTask: {
      immediate: true,
      handler() {
        this.getContactPayFile();
      },
    },
  },
  methods: {
    formatMoney(v) {
      let m = parseFloat(v);
      return isNaN(m) ? "" : thousandSplit(Math.round(m * 100) / 100 + "");
    },
    twoFixed(v) {
      console.log("v====", v);
      let m = parseFloat(v);
      return isNaN(m) ? "" : thousandSplit(m.toFixed(2) + "");
    },
    showFeelModal(id, textNumber, item) {
      this.fukuanId = id;
      this.feedModal = true;
    },
    deleteApply(row) {
      const params = {
        id: row.kfId,
        state: 12,
      };

      this.$http
        .post(Task.financeAudit, this.qs.stringify(params), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "作废成功";
            this.getContactPayFile();
            this.$emit("refresh-task-data");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    exporthetongfukuanlist() {
      const routeData = this.$router.resolve({
        name: "WindowPrint",
        query: {
          type: "payment",
          hetongId: this.taskData.info.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getContactPayFile() {
      this.$http
        .post(
          Task.getContactPayFile,
          this.qs.stringify({ hetongId: this.selectedTask.id }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          const _data = res.data;
          if (_data.retCode === 0) {
            this.contactPayFile = _data.retData.data;
            this.contactPayFile.map((item) => {
              item.applyBtn = false;
              item.rejectBtn = false;
            });
            console.log(this.contactPayFile, "res===");
            this.newfukuanexport = _data.retData.new_fukuan_export;
          }
        });
    },
    hetongseal(state) {
      if (state == 2) {
        this.hetongApproved = true;
      } else {
        this.hetongunApproved = true;
      }
      let formData = {
        hetongId: this.taskData.info.id,
        flowState: state,
        reason: this.zhijianReason,
      };
      this.$http
        .post(Task.hetongseal, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          this.hetongApproved = false;
          this.hetongunApproved = false;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            console.log("1234567890");
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.$emit("refresh");
            this.$store.dispatch("setRefresh");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    hetongsealfile(state) {
      if (!this.newTaskAddress.fileName) {
        this.isToast = true;
        this.toastMsg = "请输入文件";
        setTimeout(() => {
          this.isToast = false;
          this.toastMsg = "";
        }, 1500);
        return;
      }

      if (!this.newTaskAddress.url) {
        this.isToast = true;
        // 之前是公盘
        this.toastMsg = "请输入企业微信云盘地址";
        setTimeout(() => {
          this.isToast = false;
          this.toastMsg = "";
        }, 1500);
        return;
      }
      let checkAdress = yunzhouAdress(this.newTaskAddress.url);
      console.log(checkAdress, "checkAdress------");
      console.log(this.newTaskAddress.url, "this.newTaskAddress.url------");

      if (checkAdress !== true) {
        this.isToast = true;
        this.toastMsg = checkAdress;
        setTimeout(() => {
          this.isToast = false;
          this.toastMsg = "";
        }, 1500);
        return;
      }
      if (!this.newTaskAddress.url) {
        this.isToast = true;
        // 之前是公盘
        this.toastMsg = "请输入企业微信云盘地址";
        setTimeout(() => {
          this.isToast = false;
          this.toastMsg = "";
        }, 1500);
        return;
      }
      this.hetongSumit = true;
      let formData = {
        hetongId: this.taskData.info.id,
        fileName: this.newTaskAddress.fileName,
        fileAddress: this.newTaskAddress.url,
      };
      this.$http
        .post(Task.hetongsealfile, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");
            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功，请等待合同盖章文件审批";
          }
          setTimeout(() => {
            this.isToast = false;
            this.$store.dispatch("setRefresh");
          }, 1500);
          this.hetongSumit = false;
        });
    },
    showModal(state) {
      this.isModal = true;
      this.nopassState = state;

      if (+state === 7) {
        this.modalValue = defaultPlaceholder[this.taskData.info.toolkitId]
          ? defaultPlaceholder[this.taskData.info.toolkitId].quality
          : defaultPlaceholder["default"].quality;
      } else if (+state === 9) {
        this.modalValue = defaultPlaceholder[this.taskData.info.toolkitId]
          ? defaultPlaceholder[this.taskData.info.toolkitId].audit
          : defaultPlaceholder["default"].audit;
      } else {
        this.modalValue = "";
      }
    },
    clearModalValue() {
      this.modalValue = "";
    },
    confirmPay(id, state) {
      this.$http
        .post(
          Task.hetongkfmoney,
          this.qs.stringify({ kfId: id, flowState: state }),
          {
            headers: { Authorization: "Bearer " + this.$cookie.get("token") },
          }
        )
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功";

            this.getContactPayFile();
            this.$emit("refresh");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    reviewFukuan(id, state, item) {
      let formData = {
        id,
        state,
      };

      item.row.applyBtn = true;

      this.$forceUpdate();
      this.$http
        .post(Task.financeAudit, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
            item.applyBtn = false;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功";
            item.applyBtn = false;

            this.getContactPayFile();
            this.$emit("refresh");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    review(state) {
      let formData = {
        id: this.taskData.info.id,
        state: state,
        // reason: "名字太短"
        taskData: this.taskAddress,
        taskForm: this.taskData.formInfo[this.activeVer].formContent,
      };
      this.$http
        .post(Task.financeAudit, this.qs.stringify(formData), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.$emit("refresh");
            this.$store.dispatch("setRefresh");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    addQuotation() {
      const tax =
        this.formContent.secondModifyInfo.taxRate.value === ""
          ? 6
          : this.formContent.secondModifyInfo.taxRate.value;
      this.$router.push({
        path:
          "/tasks/add/" +
          this.projectInfo.customerId +
          "/" +
          this.projectInfo.projectId +
          "/" +
          7 +
          "/" +
          17,
        query: {
          id: this.taskData.info.id,
          tax,
        },
      });
    },
    audit(state, reason, taskData, id) {
      if (this.canAudit) {
        this.canAudit = false;
        let data = {
          id: this.selectedTask.id,
          state,
          reason,
          taskData,
          taskPersonId: id,
        };

        this.$http
          .post(Task.audit, this.qs.stringify(data), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token"),
            },
          })
          .then((res) => {
            let _data = res.data;

            if (_data.retCode === 0) {
              this.filesForm = [
                {
                  fileName: "",
                  url: "",
                  contactsAccount: null,
                  taxRate: null,
                },
              ];
              this.isToast = true;
              this.toastMsg = "提交成功";
              this.toastState = "success";
              this.$emit("refresh");
              this.$store.dispatch("setRefresh");
            } else {
              this.isToast = true;
              this.toastMsg = _data.retMsg;
              this.toastState = null;
            }
            setTimeout(() => {
              this.isToast = false;
              this.toastMsg = null;
              this.toastState = null;
              this.canAudit = true;
              if (_data.retCode === 100014) {
                this.$cookie.delete("token");

                this.$router.push("/");
              } else if (_data.retCode === 0) {
                this.$emit("refreshTaskData");
              }
            }, 1500);
          });

        this.isModal = false;
        this.isSubmit = false;
      }
    },
    changeVer(num) {
      this.$emit("on-change", num);
    },
    getSupplier() {
      const data = {
        customerId: this.customerId,
      };
      this.$http
        .post(Task.classPartB, this.qs.stringify(data), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          const _data = res.data;
          if (_data.retCode === 0) {
            this.suppliers = _data.retData.data;
          }
        });
    },
    submitAdvice() {
      console.log("hhhhhh");
      this.rejectBtn = true;
      this.$http
        .post(
          Task.financeAudit,
          this.qs.stringify({ id: this.fukuanId, state: 7, reason: this.repo }),
          {
            headers: { Authorization: "Bearer " + this.$cookie.get("token") },
          }
        )
        .then((res) => {
          this.feedModal = false;
          this.rejectBtn = false;
          let _data = res.data;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.$router.push("/");
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功";

            this.getContactPayFile();
            this.$emit("refresh");
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
  },
  mounted() {
    this.$http
      .post(
        Task.getReviewProcess,
        this.qs.stringify({
          hetongId: this.taskData.info.id,
        }),
        { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
      )
      .then((res) => {
        if (res.data.retCode === 0) {
          console.log(res.data.retData, "res.data.retData----");
          const _data=res.data.retData.process
          this.gaizhangProcess = [..._data.gaizhang_process,..._data.alreay_gaizhang_process,];//盖章
          this.dakuanProcess = res.data.retData.process.dakuan_process;//盖章

          // for(let i=0;i<){}
          // try {
          //   this.logListOne.forEach((i, k) => {
          //     if (i.content !== "审核通过") {
          //       console.log("hhhhhh------");
          //       this.logListOne[k - 1].grayRight = true;
          //       throw new Error();
          //     }
          //   });
          // } catch (err) {
          //   console.log(err);
          // }
        }
      });
  },
};
</script>

<style lang="less"  scoped>
.default-form {
  /deep/.ivu-form-item-label {
    text-align: left;
    padding-left: 20px;
  }
}

.contract-form-group {
  border-bottom: none !important;
  /deep/.ivu-form-item-label {
    text-align: left;
    padding-left: 20px;
  }
  /deep/.ivu-input {
    height: 53px;
    border: none;
    padding-left: 20px;
  }
}
.new-item {
  border-bottom: 1px solid #ced4da !important;
}
.file-log-title {
  margin-bottom: 10px;
  margin-top: 20px;
}
/deep/.main-list th {
  border: 0 none !important;
}

.no-padding {
  input {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
.form-detail {
  /deep/ .ivu-form-item-label {
    font-weight: bolder;
  }
  .title-bar-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .icon-bar {
      display: flex;

      .icon-item {
        margin-right: 30px;

        .ivu-tooltip {
          vertical-align: middle;
        }

        .name {
          margin-left: 6px;
          vertical-align: middle;
        }
      }
    }
  }
}
.infor-account {
  > h3 {
    margin: 20px 0 10px 0;
  }
}
.container {
  position: relative;
  background: white;
  padding-left: 30px;
  border: 30px solid white;
  > h3 {
    margin-bottom: 10px;
  }
  .ver-tabs {
    position: absolute;
    top: 0px;
    left: -32px;
    width: 32px;
    ul {
      li {
        background-color: #f8f9fa;
        color: #343a40;
        font-size: 14px;
        border: solid 1px #e9ecef;
        border-right: 0 none;
        border-radius: 4px 0 0 4px;
        line-height: 48px;
        text-align: center;
        margin-bottom: -1px;
        cursor: pointer;
        &.active,
        &:hover {
          color: #fff;
          background-color: #107cd9;
        }
      }
    }
  }
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.addFile {
  height: 40px;
  background-color: white;
  color: #2d8ef8;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ver-tabs {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  ul {
    li {
      background-color: #f8f9fa;
      color: #343a40;
      font-size: 14px;
      border: solid 1px #e9ecef;
      border-right: 0 none;
      border-radius: 4px 0 0 4px;
      line-height: 48px;
      text-align: center;
      margin-bottom: -1px;
      cursor: pointer;
      &.active,
      &:hover {
        color: #fff;
        background-color: #107cd9;
      }
    }
  }
}
.border {
  border: 1px solid #ced4da;
}
.border-bottom {
  border-bottom: 1px solid #ced4da;
}
.file {
  border-bottom: 1px solid #ced4da;
  .text-center {
    text-align: center;
    height: 30px;
    line-height: 30px;
    &:nth-child(2n-1) {
      border-right: 1px solid #ced4da;
    }
  }
  &:first-child {
    background: #f1f3f5;
  }
  &:last-child {
    border-bottom: 0;
  }
}

.contract-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  .btn {
    margin-left: 10px;
    width: 140px;
    height: 48px;
    font-size: 14px;
    &:first-child {
      margin-left: 0;
    }
  }
  .ghost-btn {
    border: 1px solid #2d8ef8;
    color: #2d8ef8;
  }
}
.gray {
  color: #adb5bd;
}
.blue {
  color: #2d8ef8;
}
.new-table {
  .new-inspect {
    border: 1px solid #ced4da;
    border-top: none;
    margin-bottom: 20px;
    color: #606266 !important;
    /deep/ .ivu-form-item-label {
      font-weight: normal !important;
    }
  }
  .inspectedReason-jump {
    height: 53px;
    line-height: 53px;
    font-size: 14px;
    padding-left: 10px;

    a:hover {
      // color: red !important;
    }
  }
}
.new-required-label {
  /deep/.ivu-form-item-label {
    margin-left: -10px;
  }
}

.print-process {
  display: flex;
  align-items: center;
  width: 100%;
  &-circle {
    width: 12px;
    height: 12px;
    background: rgba(45, 142, 248, 0.4);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      width: 4px;
      height: 4px;
      background: #2d8ef8;
      border-radius: 50%;
    }
  }

  &-circle--gray {
    background: rgba(206, 212, 218, 0.4);

    > div {
      background: #ced4da;
    }
  }

  &-dashed--left {
    border-top: 1px dashed #2d8ef8;
    flex: 1;
    margin-right: 10px;
  }

  &-dashed--left--gray {
    border-top: 1px dashed #ced4da;
  }

  &-dashed--right {
    border-top: 1px dashed #2d8ef8;
    flex: 1;
    margin-left: 10px;
  }

  &-dashed--right--gray {
    border-top: 1px dashed #ced4da;
  }

  .noShow {
    visibility: hidden;
  }
}

.window_print-content-remiburse-content {
  margin-top: 20px;
  box-sizing: border-box;
  // border: 1px solid #ced4da;

  &-node {
    display: flex;
    > div {
      &:first-child {
        width: 120px;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #f8f9fa;
        border-right: 1px solid #ced4da;
        color: #66707a;
        font-weight: bolder;
      }
     
    }
    .all-part{
        flex: 1;
        padding: 30px 0 0 0;
        overflow: hidden;
    }
     .one-part {
        display: flex;
        align-items: flex-end;
        // justify-content: center;
        color: #495057;
        margin-bottom: 30px;
        .title{
          padding-left: 30px;
          white-space: nowrap;
          
        }
        .all-process {
          width:150px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }
      }
  }
}
.all-cost {
  width: 100%;
  margin: 20px 0;
  width: 1100px;
  border: none;
  border-collapse: collapse;
  border-top: solid #ced4da 1px;
  border-right: solid #ced4da 1px;
  td,
  th {
    border-left: solid #ced4da 1px;
    border-bottom: solid #ced4da 1px;
  }

  .all-title {
    display: inline-flex;
    width: 100%;
    .title {
      width: 120px;
      // background: #FFE699;
      background: #e1dfdf;
      padding-left: 5px;
      text-align: left;
    }
    .last-title {
      flex: 1;
    }
  }
  .xiaolei_info {
    display: inline-flex;
    font-style: italic;
    > td {
      width: 120px;
      display: flex;
      // justify-content: center;
      align-items: center;
      padding: 0 5px;
      word-break: break-all;
    }
    .number_money {
      justify-content: end;
    }
    .last-content {
      width: 138px;
    }
  }
  .xiaolei_text {
    font-style: normal;
  }
  .dalei_info {
    font-weight: bolder;
  }
}
.compliance-specification {
  margin: 20px 0;
  text-indent: 2em;
  // span{
  //   visibility: hidden;
  // }
}
.sign_name {
  span {
    color: #b2b2b2;
    font-style: italic;
  }
}
</style>


